<template>
  <div class="home">
    <div class="sub_banner banner_swiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in banner_data"
          :key="index"
        >
          <video
            :src="item.exp2 && item.exp2.url ? $imgurl + item.exp2.url : ''"
            autoplay
            muted
            v-if="item.exp2"
          ></video>

          <img
            :src="item.exp1 && item.exp1.url ? $imgurl + item.exp1.url : ''"
            :alt="item.title"
            class=""
            v-else
          />
          <div class="txt">
            <div class="t1" v-html="item.title" v-if="item.title"></div>
            <div class="t2" v-html="item.entitle" v-if="item.entitle"></div>
            <a
              @click="tofina(item.link)"
              class="more_btn cursor"
              v-if="item.link"
              >了解更多 &nbsp;<svg
                width="7"
                height="12"
                viewBox="0 0 7 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.0533 6.05328C6.34619 5.76039 6.34619 5.28551 6.0533 4.99262L1.28033 0.219648C0.987437 -0.073245 0.512564 -0.073245 0.21967 0.219648C-0.0732231 0.512542 -0.0732231 0.987415 0.21967 1.28031L4.46231 5.52295L0.21967 9.76559C-0.0732231 10.0585 -0.0732231 10.5334 0.21967 10.8263C0.512564 11.1191 0.987437 11.1191 1.28033 10.8263L6.0533 6.05328ZM4.52297 5.52295V6.27295H5.52297V5.52295V4.77295H4.52297V5.52295Z"
                  fill="white"
                /></svg>
              </a>
          </div>
        </div>
      </div>
      <div
        class="pagination2 swiper-pagination"
        v-if="banner_data.length > 1"
      ></div>
      <div class="swiper_btn prev_btn" v-if="banner_data.length > 1">
        <svg
          width="15"
          height="28"
          viewBox="0 0 15 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.6142 2.29808L3.0931 13.9337L14.5396 25.7417C15.0477 26.2603 15.0458 27.1028 14.5357 27.6236H14.5356C14.0255 28.1444 13.2 28.1462 12.6922 27.4945L0.481815 15.0311C0.317101 14.843 0.127798 14.6207 0.0964088 14.5007C-0.0964718 14.0114 7.72476e-05 13.4102 0.385927 12.916L12.7669 0.278492C13.2793 -0.111115 14.1085 -0.113143 14.6187 0.40764C15.1288 0.928423 15.1269 1.77478 14.6142 2.29808Z"
            fill="white"
          />
        </svg>
      </div>
      <div class="swiper_btn next_btn" v-if="banner_data.length > 1">
        <svg
          width="15"
          height="28"
          viewBox="0 0 15 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.385831 2.29808L11.9069 13.9337L0.460397 25.7417C-0.047654 26.2603 -0.045843 27.1028 0.464327 27.6236H0.46437C0.97454 28.1444 1.79997 28.1462 2.30775 27.4945L14.5182 15.0311C14.6829 14.843 14.8722 14.6207 14.9036 14.5007C15.0965 14.0114 14.9999 13.4102 14.6141 12.916L2.23306 0.278492C1.72072 -0.111115 0.891499 -0.113143 0.381285 0.40764C-0.12884 0.928423 -0.126855 1.77478 0.385831 2.29808Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
    <div class="box_g">
      <!-- 新闻 -->
      <div class="title">
        <span class="z2">最新动态</span>
        <p class="mis">NEWS</p>
      </div>

      <div class="cont">
        <div class="right swiper_card">
          <div class="swiper-wrapper">
            <div
              class="lefr_z swiper-slide"
              v-for="(item, index) in [
                index_cptd[0],
                index_cptd[1],
                index_cptd[2]
              ]"
              v-if="item"
              @click="toview2(item.url)"
            >
              <div class="image hover-deepen">
                <img
                  :src="item && item.photo ? $imgurl + item.photo.url : ''"
                  alt=""
                />
              </div>
              <div class="txt">
                <div
                  class="txt_one es2"
                  @click="toview2(item.url)"
                  v-if="item && item.title"
                >
                  {{ item.title }}
                </div>
                <div class="txt_two" v-if="item && item.timeline">
                  {{ item.timeline }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="swiper-pagination"
            v-if="index_cptd && index_cptd.length > 1"
          ></div>
        </div>
        <!-- 后四条 -->
        <!-- <div class="left">
          <div
            class="sam_txt"
            v-for="(item, index) in [
              index_cptd[2],
              index_cptd[3],
              index_cptd[4],
              index_cptd[5]
            ]"
            :key="index"
            @click="toview(item.id)"
          >
            <div class="h_txt es2" v-if="item && item.title">
              {{ item.title }}
            </div>
            <div class="h_txt2" v-if="item && item.timeline">
              {{ item.timeline }}
            </div>
          </div>
        </div> -->
        <a href="/news/company">MORE +</a>
      </div>
    </div>
    <div class="box2">
      <div class="txt">
        <!--   业务领域
        <div class="img">
          <img src="../assets/imgapp/business@2x.png" alt="" />
        </div> 
        -->
        <span class="z2">业务领域</span>
        <p class="mis">business</p>
      </div>
    </div>

    <div class="box3">
      <my-amit :ind="selected"></my-amit>

      <div class="text" v-if="index_trade[0]">
        <div class="txt" @click="tobusi">{{ index_trade[selected].title }}</div>
        <div v-html="index_trade[selected].content" @click="tobusi"></div>

        <div class="imglogo">
          <img
            :src="
              index_trade[selected].exp1 &&
                $imgurl + index_trade[selected].exp1.url
            "
            alt=""
          />
        </div>
      </div>
      <div class="tabs" v-if="index_trade[0]">
        <div
          class="tablist cursor"
          :class="[{ hover: selected == index }]"
          v-for="(item, index) in index_trade2"
          :key="index"
          @click="selected = index"
          @mousemove="secuind = index"
          @mouseout="secuind = -1"
        >
          <img
            :src="
              selected == index
                ? item.exp3 && $imgurl + item.exp3.url
                : item.exp2 && $imgurl + item.exp2.url
            "
            alt=""
          />
          <div class="txt">{{ item.title }}</div>
        </div>

        <!-- <div class="txt_w">
          <div class="txt_a" @click="toPath(index_trade[selected].id)">
            MORE .
          </div>
        </div> -->
      </div>
    </div>

    <div class="box4">
      <div class="title">
        <span class="z2">行业解决方案</span>
        <p class="mis">SOLUTION</p>
        <!-- <img src="../assets/img01/SOLUTION.png" alt="" class="" /> -->
      </div>
      <div class="tabs">
        <ul>
          <li
            @click="chan(index)"
            v-for="(item, index) in index_solution2"
            :key="index"
            v-if="item.photo"
          >
            <div>
              <div class="top">
                <img
                  :src="
                    curindex == index && flg
                      ? item.exp2 && $imgurl + item.exp2.url
                      : item.photo && $imgurl + item.photo.url
                  "
                  alt=""
                />
                <img
                  class="img_01"
                  src="../assets/imgapp/dian.png"
                  alt=""
                  v-show="curindex == index && flg"
                />
                <div class="text">{{ item.title }}</div>
              </div>
              <div class="bottom">
                <img
                  :class="curindex == index && flg ? 'img_s' : ''"
                  src="../assets/imgapp/home_i.png"
                  alt=""
                />
              </div>
            </div>

            <div
              class="box_b"
              :class="curindex == index && flg ? 'active' : ''"
              :style="{
                background: `url(${$imgurl + item.exp1.url})0 0/cover no-repeat`
              }"
            >
              <div class="box_b_in">
                <div
                  class="txtx"
                  v-for="(item2, index2) in item.second"
                  :key="index2"
                >
                  <p
                    v-html="item2.title"
                    @click="toindu(index, item2.id, item.id)"
                  ></p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="box5" @click="toclik">
      <div class="txt">成为全球领先的金融科技公司</div>
      <div class="btn">了解更多</div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import myAmit from "@/components/amit";
import until from "@/untils/until";
export default {
  components: {
    myAmit
  },
  data() {
    return {
      //业务领域
      index_trade: [],
      index_trade2: [],
      selected: 0,
      flg: false,
      //轮播
      index_news: [],
      //行业解决方案
      index_solution: [],
      index_solution2: [],
      curindex: 0,
      mySwiper: null,
      index_cptd: [],
      banner_swiper: null,
      banner_data: [
        {
          title: "",
          entitle: "",
          files: {
            id: "",
            alt: "",
            origin_name: "",
            text: "",
            title: "",
            url: ""
          },
          link: "",
          photo: {
            id: "",
            alt: "",
            origin_name: "",
            text: "",
            title: "",
            url: ""
          }
        }
      ]
    };
  },
  methods: {
    //数据请求
    getdata() {
      this.$fetch({
        url: "index.php/welcome/index",
        type: "get"
      }).then((res) => {
        this.banner_data = res.data?.video;
        // this.index_news = res.data.index_news;
        this.index_cptd = res.data.index_cptd;
        // this.index_hd = res.data.index_hd;
        this.index_hssj = res.data.index_hssj;
        this.index_trade = res.data.index_trade;
        this.index_solution = res.data.index_solution;

        this.createArray();
        this.createArray2();
        console.log(this.index_trade2);
        this.$nextTick(() => {
          // this.getswiper();
          this.initSwiper();
        });
      });
    },

    initSwiper() {
      this.banner_swiper = new Swiper(".banner_swiper", {
        autoplay: 6000,
        slidesPerView: 1,
        // loop:true,
        effect: "fade",
        fadeEffect: {
          crossFade: false
        },
        speed: 500,
        pagination: ".banner_swiper .pagination2",
        paginationClickable: true,
        prevButton: ".banner_swiper .prev_btn",
        nextButton: ".banner_swiper .next_btn",
        onSlideChangeStart: (swiper) => {
          this.slideChange(swiper);
        }
      });
      // 行业应用导航
      this.nav_list = new Swiper(".nav_list", {
        slidesPerView: 5,
        spaceBetween: 10,
        speed: 500,
        slideToClickedSlide: true,
        mousewheelControl: true
      });
      // 新闻活动
      this.swiper_card = new Swiper(".box_g .swiper_card", {
        slidesPerView: 1,
        spaceBetween: 30,
        autoplay: 5000,
        speed: 500,
        pagination: ".swiper_card .swiper-pagination",
        paginationClickable: true,
        autoplayDisableOnInteraction: false
      });
    },
    // banner切换 监听是否有视频
    slideChange(swiper) {
      if (document.querySelector(".sub_banner .swiper-slide-active video")) {
        swiper.stopAutoplay();
        this.playVideo(swiper);
      } else {
        this.videoStop();
      }
    },
    // banner视频播放
    playVideo(swiper) {
      const currentVideo = document.querySelector(
        ".sub_banner .swiper-slide-active video"
      );
      if (currentVideo) {
        currentVideo.play().catch((err) => {
          console.warn("视频播放失败:", err);
        });
        this.videoPlaying(swiper);
      }
    },
    videoStop() {
      // 获取所有 slide 中的 video 元素
      const allVideos = document.querySelectorAll(
        ".sub_banner .swiper-slide video"
      );
      if (allVideos.length === 0) return; // 没有视频，直接返回
      // 暂停其他视频 重置进度条
      allVideos.forEach((video) => {
        if (video && !video.paused) {
          video.pause();
          video.currentTime = 0; // 重置进度条（可选）
        }
      });
    },
    //  视频监听
    videoPlaying(swiper) {
      // 视频播放完成
      const videoExists =
        document.querySelectorAll(".sub_banner .swiper-slide-active video")
          .length > 0;
      if (!videoExists) return;
      document
        .querySelector(".sub_banner .swiper-slide-active video")
        .addEventListener("ended", () => {
          setTimeout(() => {
            // swiper.slideNext();
            swiper.startAutoplay();
          }, 1000);
        });
    },

    createArray() {
      this.index_trade.forEach((item) => {
        if (item.title != "行业咨询") {
          this.index_trade2.push(item);
        }
      });
    },
    createArray2() {
      this.index_solution.forEach((item) => {
        if (item.title != "行业解决方案") {
          this.index_solution2.push(item);
        }
      });
    },
    //li点击展开
    chan(index) {
      console.log(index);
      if (this.curindex == index) {
        this.flg = !this.flg;
        return;
      }
      this.flg = true;
      this.curindex = index;
    },
    //swiper点击跳外链
    tolink(url) {
      window.open(url, "_block");
    },
    //点击跳关于我们
    toclik() {
      this.$router.push({ path: "/about" });
    },
    //跳页面指点位置
    toindu(index, id, crid) {
      this.$router.push({ path: "/industry", query: { index, id, crid } });
    },
    //跳业务领域
    tobusi() {
      this.$router.push({ path: "/business" });
    }

    // $(".box4 .cont .left_list").each(function(){
    //   if($(this).find(".bar").html() == "信托"){
    //     $(this).stop().hide();
    //   }
    // })
  },
  mounted() {
    this.getdata();
    
    // console.log(until.getMobileOS());
    
  }
};
</script>

<style scoped>
.es {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.es2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制行数 */
  -webkit-box-orient: vertical;
}
.es5 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5; /* 限制行数 */
  -webkit-box-orient: vertical;
}
@font-face {
  font-family: "DingTalk JinBuTi";
  src: url("../assets/fonts/DingTalk JinBuTi.ttf");
}
.mis {
  font-family: "MISANS-SEMIBOLD";
  font-size: 58px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 88px;
  line-height: 1;
  z-index: 0;
  color: #bdc1cc;
  opacity: 0.09;
  font-weight: 600;
}

.z2 {
  position: relative;
  z-index: 2;
}
.sub_banner {
  width: 100%;
  overflow: hidden;
  height: 1080px;
  position: relative;
}

.sub_banner .swiper-wrapper,
.sub_banner .swiper-slide {
  position: relative;
  width: 100%;
  height: 100%;
}
.sub_banner .swiper-slide img,
.sub_banner .swiper-slide video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sub_banner .swiper-slide .txt {
  width: 80%;
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.sub_banner .swiper-slide .txt .t1 {
  font-family: "DingTalk JinBuTi";
  font-size: 48px;
  line-height: 82px;
  text-align: center;
  color: #fff;
}
.sub_banner .swiper-slide .txt .t2 {
  margin-bottom: 49px;
  margin-top: 18px;
  color: #fff;
  text-align: center;
  text-shadow: 0 5px 20px rgba(30, 136, 240, 0.25);
  font-size: 28px;
  line-height: 1.2;
  letter-spacing: 20%;
}
.sub_banner .swiper-slide .txt .more_btn {
  width: 35%;
  height: 70px;
  border: 1px solid #fff;
  border-radius: 2px;
  overflow: hidden;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 28px;
}
.sub_banner .swiper-slide .txt .more_btn svg{
  margin-left: 20px;
  margin-top: 4px;
}
.sub_banner .swiper_btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  cursor: pointer;
}
.sub_banner .swiper_btn:hover {
  opacity: 0.8;
}
.sub_banner .swiper_btn.swiper-button-disabled {
  opacity: 0.5;
  pointer-events: none;
}
.sub_banner .prev_btn {
  left: 4%;
}
.sub_banner .next_btn {
  right: 4%;
}
.sub_banner .pagination2 {
  position: absolute;
  left: 50%;
  bottom: 40px;
  transform: translateX(-50%);
}
::v-deep.sub_banner .pagination2 span {
  width: 15px;
  height: 15px;
  margin: 0 10px;
  border-radius: 50%;
  opacity: 0.5;
  position: relative;
  border-radius: 50%;
  background-color: #fff !important;
}
::v-deep.sub_banner .pagination2 span.swiper-pagination-bullet-active {
  opacity: 1;
}

.box_g {
  width: 100%;
  height: auto;
  background: linear-gradient(161deg, #ffffff 0%, #ebeef0 100%);
}

.box_g .title {
  width: 160px;
  height: 239px;
  margin: 0 auto;
  font-size: 36px;
  font-weight: 400;
  color: #333333;
  line-height: 50px;
  letter-spacing: 4px;
  position: relative;
  display: flex;
  align-items: center;
  padding-top: 60px;
}
.box_g .title span {
  position: relative;
  z-index: 1;
}
.box_g .title img {
  width: 270px;
  height: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 0;
  transform: translate(-50%, -50%);
}
.box_g .cont {
  width: 100%;
  padding: 0 6% 15%;
  overflow: hidden;
}
.box_g .cont a {
  width: 100%;
  display: block;
  text-align: right;
  margin-top: 27px;
  color: #4a47ff;
  line-height: normal;
  font-size: 28px;
}

.box_g .cont .left {
  width: 100%;
  height: auto;
  margin-right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 2px solid rgba(51, 51, 51, 0.1);
}

.box_g .cont .right {
  width: 100%;
  height: auto;
}

.box_g .sam_txt {
  width: 100%;
  padding: 40px 4% 42px;
  border-bottom: 2px solid rgba(102, 102, 102, 0.05);
}
.box_g .sam_txt:last-child {
  border-bottom: 0;
}
.box_g .h_txt {
  font-size: 30px;
  font-weight: 450;

  color: #333333;
  cursor: pointer;
}

.box_g .h_txt2 {
  font-size: 24px;
  font-weight: 400;
  color: #333333;
  line-height: 1;
  margin: 30px 0 0;
  cursor: pointer;
}
.box_g .swiper-wrapper {
  align-items: stretch;
}
::v-deep.box_g .swiper-pagination {
  position: relative;
  bottom: auto;
  left: auto;
  right: auto;
  top: auto;
  margin-bottom: 0;
  margin-top: 20px;
}
::v-deep.box_g .swiper-pagination span {
  width: 15px;
  height: 15px;
  margin: 0 10px;
  border-radius: 50%;
  opacity: 0.3;
  position: relative;
  background-color: #666;
}
::v-deep.box_g .swiper-pagination span.swiper-pagination-bullet-active {
  opacity: 1;
  background-color: #4a47ff;
}
.box_g .lefr_z {
  display: flex;
  width: 100%;
  height: auto;
  flex-direction: column;
  margin-left: 0;
  margin-bottom: 60px;
}

.box_g .lefr_r {
  padding-right: 0;
}

.box_g .lefr_z .image {
  width: 100%;
  height: 660px;
  cursor: pointer;
  overflow: hidden;
}

.box_g .lefr_z .image img {
  width: 100%;
  height: 100%;
  transition: all 0.3s linear;
}

.box_g .lefr_z .txt {
  /* // margin: 37px 0 16px 0; */
  font-size: 28px;
  color: #333333;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  height: auto;
  padding: 33px 27px 31px;
  background: #fff;
}
.box_g .lefr_z .txt_one {
  height: 42px;
  font-size: 28px;
  line-height: 1.5;
  color: #333333;
  font-weight: 450;
  cursor: pointer;
  margin-bottom: 30px;
  position: relative;
  z-index: 1;
}

.box_g .lefr_z .txt_two {
  width: 100%;
  font-size: 24px;
  font-weight: 400;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.box_g .lefr_z .txt_a {
  font-size: 12px;
  color: #396aff;
  width: fit-content;
  cursor: pointer;
}
.box2 {
  height: 239px;
  display: flex;
  align-items: center;
}
.box2 .txt {
  /* width: 160px; */
  height: 50px;
  font-size: 36px;
  font-weight: 400;
  color: #333333;
  line-height: 50px;
  letter-spacing: 4px;
  margin: 0 auto;
  position: relative;
}
.box_g .title .mis {
  top: 82px;
}
.box2 .txt .mis {
  top: -42px;
}
.box2 .img {
  position: absolute;
  top: -40px;
  left: calc(50% - 153.5px);
  z-index: -1;
}
.box2 .img img {
  width: 301px;
  height: 47px;
}

.box3 {
  width: 100%;
  height: 1100px;
  background-image: url(../assets/imgapp/bg31.png);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  background-size: cover;
}
.box3 .imglogo img {
  position: absolute;
  top: -300px;
  right: -380px;
  max-width: 200px;
  min-height: 85px;
}
.box3 .text {
  width: 324px;
  color: #fff;
  position: absolute;
  top: 340px;
  left: 30px;
}
.box3 .text > div {
  width: 512px;
  height: 120px;
  font-size: 28px;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.box3 .text .txt {
  width: fit-content;
  height: 50px;
  font-size: 36px;
  font-weight: 600;
  color: #ffffff;
  line-height: 50px;
  margin-bottom: 20px;
}
.box3 .tabs .txt_w {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: -86px;
  left: 0px;
}

.box3 .tabs .txt_a {
  height: 33px;
  font-size: 24px;
  color: #06d3da;
}
.box3 .tabs {
  width: 690px;
  margin: 0 auto 60px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  position: relative;
  z-index: 3;
}
.box3 .tablist {
  width: 230px;
  height: 156px;
  border: 1px solid #8c99f3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  position: relative;
}
.box3 .tablist::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../assets/img01/b3-tabs.png");
  opacity: 0;
  transition: all 0.5s linear;
  z-index: -1;
  background-size: cover;
}
.box3 .tablist:hover::after {
  opacity: 1;
}
.box3 .tablist:hover .txt {
  color: #4d3ddf;
  font-weight: 600;
}
.box3 .tablist.hover {
  background: url("../assets/img01/b3-tabs.png");
  background-size: cover;
}
.box3 .tablist.hover .txt {
  color: #4d3ddf;
  font-weight: 600;
}
.box3 .tablist img {
  width: 48px;
  height: 48px;
}
.box3 .tablist .txt {
  margin-top: 12px;
  font-size: 28px;
}
.box4 {
  width: 100%;
  height: auto;
  background: linear-gradient(9deg, #e3e6ed, #fff);
}

.box4 .title {
  width: max-content;
  max-width: 60%;
  height: 239px;
  margin: 0 auto;
  font-size: 36px;
  font-weight: 400;
  color: #333333;
  line-height: 50px;
  letter-spacing: 4px;
  position: relative;
  display: flex;
  align-items: center;
  padding-top: 60px;
}
.box4 .title span {
  position: relative;
  z-index: 1;
}
.box4 .title img {
  width: auto;
  height: 64px;
  position: absolute;
  left: 50%;
  top: 58%;
  z-index: 0;
  transform: translate(-50%, -50%);
}
.box4 .tabs {
  padding: 0 30px;
}
.box4 ul li > div:nth-child(1) {
  height: 118px;
  width: 100%;
  border-bottom: 1px solid #d9d9d9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
.box4 ul li:nth-child(1) {
  margin-top: 20px;
}
.box4 ul li .box_b {
  height: 0;
  overflow: hidden;
  transition: height 0.3s linear;
  background-image: url(../assets/imgapp/home_bg2.png);
  background-size: cover;
  width: 100%;
}
.box4 ul li .active {
  height: 670px;
}
.box4 ul li .box_b_in {
  height: 670px;
  margin-top: 50px;
}
.box4 ul li .box_b_in .txtx {
  padding: 10px 0 0 30px;
}
.box4 .box_b_in .txtx p {
  font-size: 24px;
  font-weight: 400;
  color: #333333;
  line-height: 42px;
  text-shadow: 10px 10px 24px rgba(255, 255, 255, 0.6);
}
.box4 .tabs .top {
  display: flex;
  align-items: center;
  position: relative;
}
.box4 .tabs .top img:nth-of-type(1) {
  max-width: 57px;
  max-height: 67px;
  margin-right: 30px;
}
.box4 .tabs .top .img_01 {
  position: absolute;
  top: -20px;
  left: -20px;
  width: 101px;
  height: 63px;
  display: none;
}
.box4 .tabs .top .text {
  font-size: 28px;
  color: #333333;
  line-height: 37px;
}
.box4 .tabs .bottom img {
  width: 32px;
  height: 32px;
  transition: all 0.3s linear;
}
.box4 .tabs .bottom .img_s {
  transform: rotate(-180deg);
  transition: all 0.3s linear;
}
.box5 {
  width: 100%;
  height: 200px;
  background: url(../assets/imgapp/home_bg3.png);
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.box5 .txt {
  margin-bottom: 24px;
  /* width: 403px; */
  height: 37px;
  font-size: 28px;
  color: #ffffff;
  line-height: 37px;
  letter-spacing: 3px;
}
.box5 .btn {
  font-size: 24px;
  font-weight: 400;
  color: #ffffff;
  border: 1px solid #ffffff;
  padding: 19px 56px;
}
</style>
